var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"tutorials-container"},[_c('h3',{staticClass:"title"},[_vm._v(_vm._s(_vm.$t(_vm.commonTutorials.step)))]),_c('Img',{staticClass:"img",attrs:{"width":_vm.width,"url":_vm.commonTutorials.img + '-' + _vm.$i18n.locale  +'.png',"alt":_vm.$t(_vm.commonTutorials.describe)}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }